import React, { useCallback, useEffect, useState } from "react";
import OftadehLayout from "../../components/OftadehLayout/OftadehLayout";
import {
	Grid,
	Typography,
	makeStyles,
	Paper,
	Box,
	TextField,
	Button,
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { Link } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { useIsMounted } from "../../helpers/useIsMounted";
import { useStore } from "../../stores/helpers/useStore";
import GameHistoryTable from "./GameHistoryTable";

const useStyles = makeStyles(() => ({
	titlePaper: {
		marginBottom: "16px",
	},
	availableSpace: {
		fontVariant: "diagonal-fractions",
		fontSize: 36,
	},
}));

const formatDate = (date) => {
	const y = date.getFullYear();
	const m = String(date.getMonth() + 1).padStart(2, "0");
	const d = String(date.getDate()).padStart(2, "0");
	return `${y}-${m}-${d}`;
};

const addDays = (dateStr, days) => {
	const [y, m, d] = dateStr.split("-").map(Number);
	const date = new Date(y, m - 1, d);
	date.setDate(date.getDate() + days);
	return formatDate(date);
};

const RecordList = (props) => {
	const classes = useStyles();
	const isMounted = useIsMounted();
	const [isLoading, setIsLoading] = useState(true);
	const [email, setEmail] = useState("");

	const [startDate, setStartDate] = useState(() => {
		const date = new Date();
		date.setDate(date.getDate() - 7);
		return formatDate(date);
	});
	const endDate = addDays(startDate, 7);

	const [teamName, setTeamName] = useState("");

	const {
		hostsStore: { userScores, getListOfUserScores },

		uiStore: { loading },
	} = useStore();

	useEffect(() => {
		// Initial fetch with default or current state values
		getListOfUserScores(startDate, endDate).then(() =>
			setIsLoading(false)
		);
	}, []); // Empty dependency array to only run once on mount

	const handleRefreshClick = () => {
		// Use the most current state values directly
		getListOfUserScores(startDate, endDate).then(() =>
			setIsLoading(false)
		);
	};

	const handleKeyDown = (event) => {
		if (event.key === "Enter") {
			handleRefreshClick();
		}
	};

	return (
		<>
			<OftadehLayout loading={loading || !isMounted || isLoading}>
				<Box style={{ marginBottom: "20px" }}>
					<h2>Previous Game Data</h2>
					{/* <Link to="/round-history" sx={{ m: 2 }}>
						Go to Round History
					</Link> */}
				</Box>
				<Box style={{ marginBottom: "20px", padding: "12px" }}>
					{/* start of week date; end date is always start + 7 days */}
					<Grid container spacing={3}>
						<Grid item xs={12} sm={6}>
							<TextField
								id="start_date"
								label="Start of Week"
								type="date"
								value={startDate}
								onChange={(e) => setStartDate(e.target.value)}
								InputLabelProps={{
									shrink: true,
								}}
							/>
						</Grid>
						<Grid item xs={12} sm={6}>
							<TextField
								id="team_name"
								label="Team Name"
								type="text"
								value={teamName}
								onKeyDown={handleKeyDown}
								onChange={(e) => setTeamName(e.target.value)}
								InputLabelProps={{
									shrink: true,
								}}
							/>
						</Grid>
						<Grid item xs={12} sm={6}>
							<TextField
								id="email"
								label="Email"
								type="text"
								value={email}
								onKeyDown={handleKeyDown}
								onChange={(e) => setEmail(e.target.value)}
								InputLabelProps={{
									shrink: true,
								}}
							/>
						</Grid>
						<Grid item xs={12} sm={4}>
							<Button
								variant="contained"
								color="primary"
								disabled={false}
								onClick={() => handleRefreshClick()}
							>
								Refresh
							</Button>
						</Grid>
					</Grid>
				</Box>

				<>
					{!!userScores?.length ? (
						<Paper style={{ padding: "5px", margintop: "10px" }}>
							<GameHistoryTable roundList={userScores.filter(game => {
								let isValid = true;
								if (email.length) isValid = game.user.email.toLowerCase().includes(email.toLowerCase());
								if (isValid && teamName.length) isValid = game.team.toLowerCase().includes(teamName.toLowerCase());
								return isValid;
							})} />
						</Paper>
					) : (
						<Grid container direction="column">
							<Alert severity="info">
								No Rounds have been historically saved yet.
							</Alert>
						</Grid>
					)}
				</>
			</OftadehLayout>
		</>
	);
};

export default observer(RecordList);
